import React from 'react';
import { View, Text } from '@react-pdf/renderer';
import { getCoveredLabel } from '@mummssoftware/utils/medications/utils';
import { styles } from '../../../utils/styles';
export const MedCoveredPDF = ({
  med
}) => /*#__PURE__*/React.createElement(View, {
  style: styles.width6
}, /*#__PURE__*/React.createElement(Text, {
  style: [styles.medsTableMainDetailsText, styles.fontWeightBold]
}, getCoveredLabel(med.coveredbyhospice)));